import PageHeader from "@/components/site/PageHeader";
import { Events, ServiceTimes } from "@/components/site/Sections";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function EventsPage() {
  usePageMeta(
    "Events & Gatherings",
    "Weekly and monthly gatherings at RE//FORM PLACE CHI — Sunday Worship, The Classroom, Fire Nights, and Prophetic Night South in Chicago.",
  );
  return (
    <div data-testid="events-page">
      <PageHeader
        crumb="Events"
        eyebrow="Events & Gatherings"
        title="What's"
        accent="Happening"
        intro="Weekly rhythms and monthly encounters — every gathering is an invitation to meet God and meet your people."
        image="/outreach/youth-group.webp"
        imagePosition="center 30%"
      />
      <Events />
      <ServiceTimes />
      <CTABand
        eyebrow="Stay In The Loop"
        title="Never Miss A Gathering"
        text="Get event announcements and updates direct to your inbox."
        primary={{ to: "/contact#newsletter", label: "Subscribe" }}
        secondary={{ to: "/new-here", label: "Plan Your Visit" }}
      />
    </div>
  );
}
